<script>
  import {
    ZOOM_DOWNLOAD_BTN,
    ZOOM_DOWNLOAD_PROMPT,
    ZOOM_WARNING_SAFARI,
  } from '../js/l10n/en_US.js';
  import Bowser from 'bowser';
  let bowser = Bowser.parse(window.navigator.userAgent);
  const showSafariWarning = bowser.browser.name === 'Safari';
</script>

<style>
  p {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
  }
</style>

<div>
  <p class="download-zoom">{ZOOM_DOWNLOAD_PROMPT}</p>
  {#if showSafariWarning}
    <p class="safari-warning-zoom">{ZOOM_WARNING_SAFARI}</p>
  {/if}
  <div>
    <a class="btn download-zoom" href="https://zoom.us/download" target="_blank">
      {ZOOM_DOWNLOAD_BTN}
    </a>
  </div>
</div>
